import { importPixel } from './pixelsUtils';

export const importDataQualityPixel = function(pathname) {
  const existentScript = document.querySelector('script[src^="https://dq.ms1222.net/52e83d65-71f0-d9ba-14af-9f10d8f0404a.png"');

  if (existentScript) {
    existentScript.remove();
  }
  
  importPixel(
    'https://dq.ms1222.net/52e83d65-71f0-d9ba-14af-9f10d8f0404a.png',
    {
      s: 'onsite',
      path: pathname,
    }
  );
}


// WEBPACK FOOTER //
// ./src/modules/pixels/pixels.js